"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComparisonPrice_1 = require("./ComparisonPrice");
exports.default = ComparisonPrice_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonPrice/index.js
// module id = 1323
// module chunks = 8